import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	categoryTitleText: {
		margin: 0
	},
	searchInput: {
		borderRadius: 6,
		padding: theme.spacing(0.5, 1),
		backgroundColor: colors.gray[50],
		"&::before": {
			borderBottom: "none"
		},
		"& svg": {
			marginRight: theme.spacing(1),
			opacity: 0.5
		}
	},
	categoryTitleIcon: {
		minWidth: "auto",
		paddingRight: theme.spacing(2),
		"& svg": {
			width: theme.spacing(1.5),
			height: theme.spacing(1.5)
		}
	},
	categoryTitleContainer: {
		padding: 0
	},
	blockContainer: {
		padding: theme.spacing(2),
		borderRadius: 6,
		borderLeft: `3px solid ${colors.yellow[400]}`,
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		cursor: "grab",
		boxShadow: `0px 2px 2px 0px ${colors.gray[100]}`,
		"&:active": {
			animationName: "$draggingBlock",
			animationDuration: "0.1s",
			animationIterationCount: "infinite"
		}
	},
	blockItem: {
		height: "100%"
	},
	blockIcon: {
		minWidth: theme.spacing(2),
		minHeight: theme.spacing(2)
	},
	blockInfoContainer: {
		flex: 1
	},
	blockInfoTitleText: {},
	blockInfoDescriptionText: {
		fontWeight: 400,
		opacity: 0.5
	},
	button: {
		position: "absolute",
		width: theme.spacing(5),
		height: theme.spacing(5),
		minWidth: theme.spacing(5),
		zIndex: 9,
		top: theme.spacing(7),
		left: 0,
		borderTopLeftRadius: 0,
		borderBottomLeftRadius: 0,
		...ColorUtil.getBackgroundAndContrastColor(colors.purple[600]),
		fontSize: theme.spacing(3),
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.purple[700])
		}
	},
	"@keyframes draggingBlock": {
		"0%": {
			opacity: 1
		},
		"99%": {
			opacity: 1
		},
		"100%": {
			opacity: 1
		}
	},
	listItem: {
		listStyleType: "disc",
		display: "list-item"
	},
	popper: {
		zIndex: 9999999,
		flexDirection: "column",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		padding: theme.spacing(1.5, 2),
		width: "379px",
		height: theme.spacing(21),
		background: colors.gray[0],
		boxShadow: "2px 9px 10px 8px rgba(0, 0, 0, 0.1)",
		borderRadius: theme.spacing(0.5),
		left: "70px !important",
		top: "90px !important"
	},
	markText: {
		fontWeight: "bold",
		"& .MuiTypography-colorTextPrimary": {
			color: colors.gray[950]
		}
	},
	fullHeight: {
		height: "100%"
	},
	asideBlockContainer: {
		paddingLeft: theme.spacing(1)
	},
	contentLayout: {
		position: "absolute",
		top: 0,
		bottom: 0,
		display: "flex",
		flexDirection: "column",
		flexWrap: "nowrap",
		overflow: "hidden"
	},
	searchSection: {
		flexShrink: 0,
		paddingBottom: theme.spacing(1.5)
	},
	blocksSection: {
		flex: 1,
		minHeight: 0,
		overflowY: "auto",
		overflowX: "hidden",
		paddingRight: theme.spacing(1),
		"&::-webkit-scrollbar": {
			width: "6px !important",
			height: "6px !important"
		},
		"&::-webkit-scrollbar-thumb": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[200])
		},
		"&::-webkit-scrollbar-track": {
			background: "hsla(0, 0%, 100%, 0.1)"
		}
	},
	chatTabs: {
		position: "relative",
		"&::before": {
			content: "close-quote",
			position: "absolute",
			width: "100%",
			height: "1px",
			bottom: 0,
			left: 0,
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[200])
		},
		marginBottom: theme.spacing(2.5)
	},
	chatTab: {
		color: `${colors.gray[700]} !important`,
		fontSize: 12
	},
	chatTabIndicator: {
		...ColorUtil.getBackgroundAndContrastColor(colors.getPrimaryColor())
	}
}))

export default useStyles
